<template>
  <div class="page dashboard-page">
    <div v-if="isSuperRole">
      <SuperHome />
    </div>
    <div v-else-if="isNoneRole">
      <NoneRoleHome />
    </div>
    <div v-else>
      <ApplicationHome />
    </div>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import SuperHome from './super_home';
  import ApplicationHome from './application_home';
  import NoneRoleHome from './none_role_home';
  import _ from 'lodash';

  @Component({
    components: {
      SuperHome,
      ApplicationHome,
      NoneRoleHome
    }
  })
  export default class Home extends Vue {
    get isSuperRole() {
      return _.get(this.$root.user, 'current_role.role.kind') === 'super';
    }

    get isNoneRole() {
      return _.get(this.$root.user, 'current_role') === null;
    }
  }
</script>

<style lang="scss">
  .dashboard-page {
    .page-title {
      padding: 8px 20px;
      border-bottom: 1px solid $border-light;
      margin: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      font-size: 14px;
      color: #fff;
      background: $primary;
    }

    .qr-code {
      width: 100px;
    }

    .section {
      @include shadow;
      margin-top: 20px;
    }

    .content {
      background: #fff;
    }

    .wrapper {
      .card {
        .page-title {
          text-align: center;
          font-weight: bold;
        }

        .content {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .item {
          flex: 1;
          height: 126.7px;
          margin: 0.5em 0;
          text-align: center;

          .pending-bind-tips {
            line-height: 126.7px;
          }

          [class^="el-icon-"] {
            font-size: 30px;
            margin-top: 10px;
          }

          .bind-button {
            margin-top: 45px;
          }

          .go-register {
            margin-top: 35px;
          }

          .tip {
            margin-top: 15px;
            margin-bottom: 20px;
            font-size: 12px;
            color: #86888b;
            padding: 0 14px;
            text-align: left;
          }

          .name {
            margin-top: 15px;
            margin-bottom: 20px;
            font-size: 14px;
            color: #86888b;
          }
        }

        .visit-table {
          flex: 1;
          margin: 0.5em 0;
          padding: 1em;
          text-align: center;

          .name {
            margin-top: 15px;
            margin-bottom: 20px;
            font-size: 14px;
            font-weight: 500;
            color: #86888b;
          }
        }
      }

      .special-card-wrapper {
        display: flex;
        margin-bottom: 15px;

        .card {
          flex: 1;
        }
      }
    }

    .el-button {
      width: 100%;
    }

    .customer-connect {
      font-size: 18px;
      color: #399e62;
      cursor: pointer;
      text-decoration-line: underline;
    }
  }
</style>
